import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../state';
import { TabSettings } from './TabSettings';

export const mapState = (state: RematchRootState<RootModel>) => ({
  connection: state.connections.connection,
  defaultRoute: state.services.defaultRoute,
  service: state.services.service,
  project: state.projects.project,
  iModelDetails: state.imodels.iModelDetails,
  namedIModelDetails: state.imodels.namedIModelDetails,
  iModelViewDetails: state.imodels.iModelViewDetails,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  loadStateFromTabData: async (context: microsoftTeams.Context) =>
    dispatch.tab.loadStateFromTabData(context),
  loadProjects: async () => dispatch.projects.loadProjects({}),
  loadServices: async () => dispatch.services.loadServices({}),
  loadConnections: async () => dispatch.connections.loadConnections({}),
});

export const ConnectedTabSettings = connect(mapState, mapDispatch)(TabSettings);
